<ion-menu side="start" menuId="mainMenu" class="my-custom-menu">
  <!-- <ion-header>
    <ion-toolbar color="primary"> -->
  <!-- <ion-title>Start Menu</ion-title> -->
  <!-- </ion-toolbar>
  </ion-header> -->
  <ion-content>
    <ion-list class="drawer-content sidebar-links">

      <ion-avatar slot="start" class="prof-margin">
        <img src="../../../assets/images/profile.jpg" class="icon icon-lg rounded-circle">
      </ion-avatar>

      <ion-item lines="none" *ngIf="!is_logged">
        <ion-label class="prof-name">{{'COMPONENTS.SLIDEMENU.WELCOME' | translate}}</ion-label>
      </ion-item>

      <ion-item lines="none" *ngIf="is_logged">
        <ion-label class="prof-name">{{userInfo.firstName}} {{userInfo.surname}}</ion-label>
      </ion-item>

      <ion-item lines="none" *ngIf="is_logged">
        <ion-label no-lines class="t t-faded">{{'COMPONENTS.SLIDEMENU.BALANCE-CURRENCY' | translate}} {{userInfo.balance
          | number: '2.'}}</ion-label>
      </ion-item>

      <!-- <ion-item> -->
      <!-- <div class="ion-page divider"></div> -->
      <!-- </ion-item> -->
      <ion-item-divider></ion-item-divider>

      <ion-menu-toggle (click)="showHomeElements()">
        <ion-item routerLink="home" lines="none">
          <a class="sidebar-link-item" [ngClass]="{'activeLINKK':showHomeElementsVar}">
            <span class="icon icon-home" slot="start"></span>
            <ion-label class="disply-line">{{'COMPONENTS.SLIDEMENU.LINKS.HOME' | translate}}</ion-label>
          </a>
        </ion-item>
      </ion-menu-toggle>

      <!-- <ion-menu-toggle (click)="showHomeIcon()">
        <ion-item routerLink="my-account/my-profile" lines="none" [disabled]="!is_logged">
          <a class="sidebar-link-item" routerLinkActive="active">
            <span class="icon icon-profile" slot="start"></span>
            <ion-label class="disply-line">{{'COMPONENTS.SLIDEMENU.LINKS.MY-ACCOUNT' | translate}}</ion-label>
          </a>
        </ion-item>
      </ion-menu-toggle>  -->

      <ion-menu-toggle (click)="showHomeIcon()">
        <ion-item routerLink="my-account/my-profile" lines="none" [disabled]="!is_logged">
          <a class="sidebar-link-item" routerLinkActive="active">
            <span class="icon icon-profile" slot="start"></span>

            <ion-label>
              <div class="disply-line">
                {{ 'COMPONENTS.SLIDEMENU.LINKS.MY-ACCOUNT' | translate }}
              </div>
              <div class="menu-sub-text">
                {{ 'COMPONENTS.SLIDEMENU.LINKS.MA-SUB-HEADING' | translate }}
              </div>
            </ion-label>
          </a>
        </ion-item>
      </ion-menu-toggle>


      <ion-menu-toggle (click)="showHomeIcon()">
        <ion-item routerLink="my-account/my-slips" lines="none" [disabled]="!is_logged">
          <a class="sidebar-link-item" routerLinkActive="active">
            <!-- <span class="icon icon-profile" slot="start"></span> -->
            <i class="bi bi-card-list icon-black" style="margin-right: 0.75rem;"></i>
            <ion-label class="disply-line">{{'COMPONENTS.SLIDEMENU.LINKS.MY-SLIPS' | translate}}</ion-label>
          </a>
        </ion-item>
      </ion-menu-toggle>

      <ion-menu-toggle (click)="showHomeIcon()">
        <ion-item routerLink="results" lines="none">
          <a class="sidebar-link-item" routerLinkActive="active">
            <span class="icon icon-results" slot="start"></span>
            <ion-label class="disply-line">{{'COMPONENTS.SLIDEMENU.LINKS.RESULTS' | translate}}</ion-label>
          </a>
        </ion-item>
      </ion-menu-toggle>

      <ion-menu-toggle (click)="showHomeIcon()">
        <ion-item routerLink="news" lines="none">
          <a class="sidebar-link-item" routerLinkActive="active">
            <span class="icon icon-news" slot="start"></span>
            <ion-label class="disply-line">{{'COMPONENTS.SLIDEMENU.LINKS.NEWS' | translate}}</ion-label>
          </a>
        </ion-item>
      </ion-menu-toggle>

      <ion-menu-toggle (click)="showHomeIcon()">
        <ion-item routerLink="book-of-rules" lines="none">
          <a class="sidebar-link-item" routerLinkActive="active">
            <span class="icon icon-book" slot="start"></span>
            <ion-label class="disply-line">{{'COMPONENTS.SLIDEMENU.LINKS.BOOK-OF-RULES' | translate}}</ion-label>
          </a>
        </ion-item>
      </ion-menu-toggle>

      <ion-menu-toggle (click)="showHomeIcon()">
        <ion-item routerLink="racing-paper" lines="none">
          <a class="sidebar-link-item" routerLinkActive="active">
            <!-- <span class="icon icon-info" slot="start"></span> -->
            <i class="bi bi-journal icon-black" style="margin-right: 0.75rem;"></i>

            <ion-label class="disply-line">{{'COMPONENTS.SLIDEMENU.LINKS.RACING-PAPER' | translate}}</ion-label>
          </a>
        </ion-item>
      </ion-menu-toggle>



      <ion-menu-toggle (click)="showHomeIcon()">
        <ion-item routerLink="about-us" lines="none">
          <a class="sidebar-link-item" routerLinkActive="active">
            <span class="icon icon-info" slot="start"></span>
            <ion-label class="disply-line">{{'COMPONENTS.SLIDEMENU.LINKS.ABOUT-US' | translate}}</ion-label>
          </a>
        </ion-item>
      </ion-menu-toggle>

      <ion-menu-toggle (click)="showHomeIcon()">
        <ion-item lines="none">
          <a class="sidebar-link-item" routerLinkActive="active" href="https://vacancies.stbet.com/" target="_blank"
            rel="noopener">
            <span class="icon icon-profile" slot="start"></span>
            <ion-label class="disply-line">{{'COMPONENTS.SLIDEMENU.LINKS.CAREERS' | translate}}</ion-label>
          </a>
        </ion-item>
      </ion-menu-toggle>

      <ion-item lines="none" class="account-align" *ngIf="is_android" style="margin-bottom: 0;">
        <a class="sidebar-link-item" routerLinkActive="active" target="_self" (click)="genApkUrl()">
          <!-- <span class="icon icon-info" slot="start"></span> -->
          <i class="bi bi-phone icon-black" style="margin-right: 0.75rem;"></i>
          <ion-label class="disply-line">{{'COMPONENTS.SLIDEMENU.LINKS.MOBILE-APP' | translate}}</ion-label>
        </a>
      </ion-item>

      <p class="version">Version : {{latestVersion}}</p>

      <div class="divider" style="margin-top: 0;"></div>

      <ion-item lines="none">
        <a class="sidebar-link-item" *ngIf="!is_logged">
          <span class="icon icon-logout" slot="start"></span>
          <button (click)="launchLogin()" class="disply-line login-btn">
            <ion-label class="disply-line">{{'COMPONENTS.SLIDEMENU.BUTTONS.LOG_IN' | translate}}</ion-label>
          </button>
        </a>

        <a class="sidebar-link-item" *ngIf="is_logged">
          <span class="icon icon-logout" slot="start"></span>
          <button (click)="click_logout()" class="disply-line login-btn">
            <ion-label class="disply-line">{{'COMPONENTS.SLIDEMENU.BUTTONS.LOG_OUT' | translate}}</ion-label>
          </button>
        </a>

      </ion-item>
      <ion-menu-toggle>
        <button class="icon icon-close" ion-button></button>
      </ion-menu-toggle>
    </ion-list>
  </ion-content>
</ion-menu>
<ion-router-outlet main></ion-router-outlet>